// client/src/pages/ShopPOS/components/PaymentModal.tsx
import { Button } from "@/components/ui/button";

interface PaymentModalProps {
  show: boolean;
  onSelectPayment: (method: "efectivo" | "transferencia" | "mixto") => void;
  onCancel: () => void;
}

export function PaymentModal({
  show,
  onSelectPayment,
  onCancel,
}: PaymentModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
      <div className="bg-background rounded-lg p-6 w-full max-w-sm">
        <h3 className="text-lg font-bold mb-4">Método de Pago</h3>
        <div className="flex flex-col gap-3">
          <Button
            size="lg"
            className="w-full"
            onClick={() => onSelectPayment("efectivo")}
          >
            Efectivo
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="w-full"
            onClick={() => onSelectPayment("transferencia")}
          >
            Transferencia
          </Button>
          {/* {esta sección agrega la opción de pago mixto: efectivo + transferencia} */}
          <Button
            size="lg"
            variant="secondary"
            className="w-full border-dashed border-2"
            onClick={() => onSelectPayment("mixto")}
          >
            Mixto (Efectivo + Transferencia)
          </Button>
          <Button
            size="sm"
            variant="ghost"
            className="w-full"
            onClick={onCancel}
          >
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
}
